"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterFilters = exports.formatNumber = void 0;
const formatNumber = (rawNum, digits = 3) => {
    if (!rawNum) {
        return '0';
    }
    const num = Number(rawNum);
    if (Number.isNaN(num)) {
        return rawNum.toString();
    }
    const lookup = [
        { value: 1, symbol: '' },
        { value: 1e3, symbol: 'k' },
        { value: 1e6, symbol: 'M' },
        { value: 1e9, symbol: 'G' },
        { value: 1e12, symbol: 'T' },
        { value: 1e15, symbol: 'P' },
        { value: 1e18, symbol: 'E' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup
        .slice()
        .reverse()
        .find(function (item) {
        return Math.abs(num) >= item.value;
    });
    return item
        ? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol
        : num.toFixed(digits);
};
exports.formatNumber = formatNumber;
const filterIsLogicalOrFilter = (filter) => {
    return filter.or !== undefined;
};
const filterIsLogicalAndFilter = (filter) => {
    return filter.and !== undefined;
};
const filterFilters = (filters, substring) => {
    return filters
        .filter(filter => filterIsLogicalOrFilter(filter) ||
        filterIsLogicalAndFilter(filter) ||
        !filter.member ||
        filter.member.includes(substring))
        .map(filter => {
        if (filterIsLogicalOrFilter(filter)) {
            return {
                or: (0, exports.filterFilters)(filter.or, substring),
            };
        }
        if (filterIsLogicalAndFilter(filter)) {
            return {
                and: (0, exports.filterFilters)(filter.and, substring),
            };
        }
        return filter;
    });
};
exports.filterFilters = filterFilters;
//# sourceMappingURL=helpers.js.map